module.exports = __webpack_public_path__ + "static/mockupDevSquad-5237991600ceb18d0b87627438bc1326.png";